// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bfh9","newExpiryDate":"styles_newExpiryDate__3Vv1-","footer":"styles_footer__34gMm"};